export default __webpack_public_path__ + "static/media/need.7e6f6167.png";